import React from "react";

// Значение и обработчик берутся из того же модуля, что и раньше: своего состояния
// разгрузки этот блок не заводит, он читает и пишет deliveryMethod.gazUnloadMethod.
import {
  UNLOAD_METHOD_OPTIONS,
  GAZ_UNLOAD_DEFAULT_METHOD,
  getGazUnloadMethod,
  applyGazUnloadMethod,
} from "./gazUnloadMethod";

import "../../theme/redesign/tokens.css";
import "../../theme/redesign/section.css";
import "./gazUnloadSection.css";

// Подписи карточек. Ключи — те же строки UNLOAD_METHOD_OPTIONS, которые уходят в
// расчёт: их переименовывать нельзя, поэтому человеческий заголовок и пояснение
// живут отдельно от значения.
const UNLOAD_CARDS = {
  "разгрузка манипулятором": {
    title: "Разгрузка манипулятором",
    hint: "Манипулятор разгружает весь объём",
  },
  "разгрузка краном": {
    title: "Разгрузка краном",
    hint: "Отдельный кран на объекте",
  },
  // Формулировка именно про шаланды: перекладывать разгрузку на клиента было бы
  // неправдой — манипулятор, который везёт остаток, разгружает свой груз и здесь.
  "без разгрузки": {
    title: "Без разгрузки",
    hint: "Разгрузка шаланд не включена",
  },
};

/**
 * «Разгрузка на объекте» — отдельный блок между «Товарами» и расчётом заказа.
 *
 * Разгрузка относится ко всему заказу и к доставке, а не к строке товара, поэтому
 * из раздела «Товары» выбор убран. Блок монтируется только внутри МСК Газобетона
 * (условие стоит в App.js), второго места выбора внутри области не остаётся.
 *
 * Разметка нативная: input[type=radio] внутри связанного label, поэтому клавиатура
 * и скринридер работают штатно, а вся карточка кликабельна как область label.
 */
function GazUnloadSection({ deliveryMethod, setDeliveryMethod }) {
  // Пока способ не проставлен, подсвечивается тот же вариант по умолчанию,
  // который подставляет расчёт.
  const selectedUnloadMethod = getGazUnloadMethod(deliveryMethod) || GAZ_UNLOAD_DEFAULT_METHOD;

  return (
    <section className="rd-section gaz-unloading-selector">
      <div className="rd-sec-head gaz-unloading-selector__head">
        <h2>
          Разгрузка на объекте
          <small>Выбирается для всего заказа</small>
        </h2>
      </div>

      <div
        className="gaz-unloading-selector__grid"
        role="radiogroup"
        aria-label="Разгрузка на объекте"
      >
        {UNLOAD_METHOD_OPTIONS.map((option) => {
          const card = UNLOAD_CARDS[option];
          const picked = selectedUnloadMethod === option;

          return (
            <label
              key={option}
              className={`gaz-unloading-selector__card${picked ? " is-picked" : ""}`}
            >
              <input
                type="radio"
                name="gaz-unload-method"
                className="gaz-unloading-selector__native"
                value={option}
                checked={picked}
                onChange={() => applyGazUnloadMethod(setDeliveryMethod, option)}
              />
              <span className="gaz-unloading-selector__dot" aria-hidden="true" />
              <span className="gaz-unloading-selector__txt">
                <span className="gaz-unloading-selector__name">{card.title}</span>
                <small className="gaz-unloading-selector__hint">{card.hint}</small>
              </span>
            </label>
          );
        })}
      </div>
    </section>
  );
}

export default GazUnloadSection;
